function hideUnavailableOptions() {
  const selectors = [
    'input[type="radio"][disabled]',
    'input[type="radio"].disabled',
    'input[type="radio"][aria-disabled="true"]',
    'input[type="radio"].unavailable',
    'input[type="radio"].soldout'
  ];

  selectors.forEach(function(selector) {
    document.querySelectorAll(selector).forEach(function(input) {
      input.style.display = 'none';
      const label = document.querySelector('label[for="' + input.id + '"]');
      if (label) label.style.display = 'none';
      if (input.parentElement) input.parentElement.style.display = 'none';
    });
  });
}

// Odpal od razu
document.addEventListener('DOMContentLoaded', hideUnavailableOptions);

// Obserwuj zmiany w DOM - reaguje gdy Horizon przeładuje opcje
const observer = new MutationObserver(function() {
  hideUnavailableOptions();
});

document.addEventListener('DOMContentLoaded', function() {
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['disabled', 'class', 'aria-disabled']
  });
});